<template>
  <div class="pt-3 pl-3">
    <v-treeview
      selectable
      :items="permisos"
      v-model="tree"
      selection-type="independent"
      item-key="id">
    ></v-treeview>  
    <v-btn class="primary mb-5"  absolute bottom right @click="guardar"> Guardar permisos</v-btn>
  </div>  
</template>
<script>

import { PersonaApiService } from '@/api/PersonaApiService'

const personaApiService = new PersonaApiService()

export default {
  props: {
    personaParam: Object,
    tabSeleccionado: Number
  },
  data() {
    return {
      tree: [],
      active: [],
      permisos: [
        {
        id: 'MOBILESTORE.GESTIONTIENDA',
        name: 'Gestión tienda',
        children: [
            {
              id: 'MOBILESTORE.GESTIONTIENDA.CALENDARIO',
              name: 'Calendario Laboral',
              children: [
                {
                  id: 'MOBILESTORE.GESTIONTIENDA.CALENDARIO.CRUD',
                  name: 'Mantenimiento calendario laboral',
                },
              ]
            },
            {
              id: 'MOBILESTORE.GESTIONTIENDA.CITAPREVIA',
              name: 'Cita previa',
              children: [
                {
                  id: 'MOBILESTORE.GESTIONTIENDA.CITAPREVIA.CRUD',
                  name: 'Mantenimiento cita previa',
                },
                {
                  id: 'MOBILESTORE.GESTIONTIENDA.CITAPREVIA.HORARIOTIENDA',
                  name: 'Horario tienda',
                }
              ]
            }
          ],
        },
        {
          id: 'MOBILESTORE.LOOKS',
          name: 'Looks',
          children: [
            {
              id: 'MOBILESTORE.LOOKS.CRUD',
              name: 'Mantenimiento looks',
            },
          ],
        },
        {
          id: 'MOBILESTORE.TIENDA',
          name: 'Tienda',
          children: [
            {
              id: 'MOBILESTORE.TIENDA.APARCAR',
              name: 'Aparcar tickets',
            },
            {
              id: 'MOBILESTORE.TIENDA.MOVSTOCK',
              name: 'Mover stock',
            },
          ],
        },
        {
          id: 'MOBILESTORE.PHONESERVICES',
          name: 'Phoneservices',
          children: [
            {
              id: 'MOBILESTORE.PHONESERVICES.TIENDA',
              name: 'Tienda',
              children: [
                {
                id: 'MOBILESTORE.PHONESERVICES.TIENDA.MOVSTOCK',
                name: 'Mover stock'
                }
              ]
            },
            {
              id: 'MOBILESTORE.PHONESERVICES.CALENDARIO',
              name: 'Calendario',
            },
            {
              id: 'MOBILESTORE.PHONESERVICES.CONTROLHORARIO',
              name: 'Fichaje',
            },
            {
              id: 'MOBILESTORE.PHONESERVICES.PEDIDOS',
              name: 'Entradas / Salidas',
            },
            {
              id: 'MOBILESTORE.PHONESERVICES.INVENTARIO',
              name: 'Inventario',
            },
            {
              id: 'MOBILESTORE.PHONESERVICES.ESTADISTICAS',
              name: 'Estadísticas',
            },
          ],
        },
      ],
    }
  },
  personaParam: {
    handler (n, o) {
      if (n.mspersonaid !== o.mspersonaid) {
        this.init()
      }
    },
    deep: true
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getAcl()
    },
    guardar() {
      function flattenDeep(arr1) {
        return arr1.reduce((acc, val) => Array.isArray(val.children) ? acc.concat(val.id, flattenDeep(val.children)) : acc.concat(val.id), []);
      }
      let permisosTotales = flattenDeep(this.permisos);
      let permisosInactivos = permisosTotales.filter(x => !this.tree.includes(x));
      let req = {
        mspersonaid: this.personaParam.mspersonaid,
        permisosActivos: this.tree,
        permisosInactivos: permisosInactivos
      }
      personaApiService.updateAclPersona(req)
      .then(data => {
        if (data.data === 'ok') {
          this.$root.$emit('mostrarAlerta', 'Permisos actualizados con exito', 'info')
        }
      })
      .catch(error => {
        this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
        console.log(error)
      })
    },
    getAcl() {
      personaApiService.getAclPersonaById(this.personaParam.mspersonaid)
      .then(data => {
        if (data.data) {
          data.data.forEach(element => {
            if (element.valor === 'S') {
              this.tree.push(element.permiso)
            }
          });
        }
      })
      .catch(error => {
        this.$root.$emit('mostrarAlerta', 'Ha ocurrido un error con el ACL', 'error')
        console.log(error)
      })
    }
  },
}
</script>